import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'
import type {ReleasesRouteComponents} from './create-releases-routes'

export const lazyReleasesRouteComponents: ReleasesRouteComponents = {
  ReleasesTagsLayoutRoute: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./ReleasesTagsLayoutRoute')
      return {default: module.ReleasesTagsLayoutRoute}
    }),
  ),
  ReleasesIndex: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./ReleasesIndex')
      return {default: module.ReleasesIndex}
    }),
  ),
  TagsIndex: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./TagsIndex')
      return {default: module.TagsIndex}
    }),
  ),
}
